/** 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 * Core owns the shared help destinations and labels.
 */
export function platformHelpUrl(baseUrl: string, path: string, origin: string): string {
  const base = new URL(baseUrl.trim() || origin, origin);
  if (!['https:', 'http:'].includes(base.protocol) || base.username || base.password) {
    throw new Error('Invalid platform help origin');
  }
  base.search = '';
  base.hash = '';
  base.pathname = base.pathname.replace(/\/+$/, '') + '/';
  return new URL(path.replace(/^\/+/, ''), base).toString();
}

export function qubeproTicketsUrl(baseUrl: string, origin: string): string {
  return platformHelpUrl(baseUrl, 'support/qubepro-tickets', origin);
}

export function globalAssistantEmbedUrl(baseUrl: string, origin: string, applicationCode: string): string {
  const url = new URL(platformHelpUrl(baseUrl, 'ai/assistant/embed', origin));
  url.searchParams.set('applicationCode', applicationCode);
  url.searchParams.set('embedded', '1');
  return url.toString();
}

const ticketsLabels: Record<string, string> = {
  tr: 'QubePro Taleplerim', en: 'My QubePro Requests', de: 'Meine QubePro-Anfragen',
  fr: 'Mes demandes QubePro', es: 'Mis solicitudes de QubePro', it: 'Le mie richieste QubePro',
  ar: 'طلباتي لدى QubePro', ru: 'Мои обращения QubePro', zh: '我的 QubePro 请求', ja: 'QubePro への問い合わせ',
};

export function qubeproTicketsLabel(language = 'tr'): string {
  return ticketsLabels[language.toLowerCase().split(/[-_]/)[0]] || ticketsLabels.en;
}

/** Only the mounted, configured AI frame may control its host panel. */
export function isAssistantFrameMessage(event: Pick<MessageEvent, 'origin' | 'source'>,
  frame: Window | null, expectedOrigin: string): boolean {
  return frame !== null && event.source === frame && event.origin === expectedOrigin;
}
